module.exports = __webpack_public_path__ + "public/Icons/adminUserIcon.png?64aa55cb";